import React from "react";

interface SelectButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
}
export const SelectButton = ({
  selected = false,
  className,
  ...props
}: SelectButton) => {
  return (
    <button
      className={
        className +
        " w-6 h-6 border-2 rounded-md min-w-6  " +
        (selected ? " bg-white" : "cursor-pointer")
      }
      type="button"
      disabled={selected}
      style={{ borderRadius: 4 }}
      {...props}
    />
  );
};
